import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/da2l8trd3r93mn1k3b8g";

const contactInfo = [
  { icon: "ri-mail-fill", label: "合作 / 投稿邮箱", value: "hello@wayway-manhua.com" },
  { icon: "ri-time-line", label: "在线响应", value: "工作日 10:00 - 19:00" },
  { icon: "ri-compass-3-line", label: "内容定位", value: "韩国恶搞 · 反转 · 脑洞 · 沙雕" },
];

const values = [
  { icon: "ri-emotion-happy-line", title: "轻松解压", desc: "用反转与脑洞让读者卸下压力、会心一笑。" },
  { icon: "ri-refund-2-fill", title: "反转优先", desc: "剧情反转是灵魂，每话都要超出预期一点点。" },
  { icon: "ri-lightbulb-flash-line", title: "脑洞无界", desc: "不设条条框框，让沙雕创意自由生长。" },
  { icon: "ri-calendar-check-line", title: "稳定追更", desc: "规律更新、状态透明，让追更成为一种习惯。" },
];

export default function AboutContact() {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("contact_alt") || "").trim();
    const submitSuccess = () => {
      setStatus("success");
      setMessage("感谢你的留言！我们会尽快回复你。");
      form.reset();
    };
    const submitError = (msg: string) => {
      setStatus("error");
      setMessage(msg || "提交失败，请稍后再试。");
    };

    if (honeypot) {
      submitSuccess();
      return;
    }

    setStatus("sending");
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText;
      if (res.ok && parsed?.code === "OK") {
        submitSuccess();
      } else {
        submitError(serverMsg);
      }
    } catch (err) {
      submitError("");
    }
  };

  return (
    <section id="contact" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="text-sm font-bold tracking-wide text-primary-600">ABOUT &amp; CONTACT</span>
            <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">关于歪歪漫画</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              韩国歪歪漫画是一处专注恶搞题材与反转剧情的漫画内容站。我们坚信，好的脑洞与神展开能让人在忙碌生活里突然笑出声来。从魔性沙雕到爆笑日常，我们持续挖掘并整理值得追更的韩国恶搞漫画，让每个无聊的瞬间都被反转填满。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们的内容遵循「轻松解压、反转优先、脑洞无界、稳定追更」的原则，分类清晰、状态透明，方便你随时找到想追的那一部。
            </p>

            <ul className="mt-6 space-y-3">
              {contactInfo.map((c) => (
                <li key={c.label} className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-lg text-accent-700">
                    <i className={c.icon}></i>
                  </span>
                  <div>
                    <div className="text-xs text-foreground-500">{c.label}</div>
                    <div className="text-sm font-medium text-foreground-900">{c.value}</div>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl border border-background-200 bg-background-100 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                    <i className={v.icon}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8">
            <h3 className="text-xl font-black text-foreground-950 md:text-2xl">联系我们 / 投稿</h3>
            <p className="mt-2 text-sm text-foreground-600">
              有脑洞想分享，或想推荐你喜欢的恶搞反转漫画？欢迎留言，我们会认真阅读每一封来信。
            </p>

            <form
              id="contact-form"
              data-readdy-form="da2l8trd3r93mn1k3b8g"
              onSubmit={handleSubmit}
              className="mt-6 space-y-4"
            >
              <input
                name="contact_alt"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <label htmlFor="name" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    你的称呼
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    placeholder="怎么称呼你"
                    className="w-full rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-foreground-800">
                    联系邮箱
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    placeholder="you@example.com"
                    className="w-full rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="subject" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  留言主题
                </label>
                <select
                  id="subject"
                  name="subject"
                  className="w-full rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                >
                  <option value="漫画推荐">漫画推荐</option>
                  <option value="脑洞投稿">脑洞投稿</option>
                  <option value="内容建议">内容建议</option>
                  <option value="合作咨询">合作咨询</option>
                  <option value="其他">其他</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="mb-1.5 block text-sm font-medium text-foreground-800">
                  留言内容
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  placeholder="写点什么，和我们分享你的脑洞吧～"
                  className="w-full resize-none rounded-lg border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                ></textarea>
                <p className="mt-1 text-right text-xs text-foreground-400">最多 500 字</p>
              </div>

              <button
                type="submit"
                disabled={status === "sending"}
                className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60 whitespace-nowrap"
              >
                {status === "sending" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i> 发送中…
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill"></i> 发送留言
                  </>
                )}
              </button>

              {status === "success" && (
                <p className="rounded-lg bg-accent-100 px-4 py-3 text-sm text-accent-900">
                  <i className="ri-checkbox-circle-fill mr-1"></i>
                  {message}
                </p>
              )}
              {status === "error" && (
                <p className="rounded-lg bg-primary-100 px-4 py-3 text-sm text-primary-800">
                  <i className="ri-error-warning-fill mr-1"></i>
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}